import React, { createRef } from "react";
import CloseIcon from "@material-ui/icons/Close";
import { Theme, IconButton, makeStyles } from "@material-ui/core";
import { SnackbarProvider } from "notistack";

const useStyles = makeStyles((theme: Theme) => ({
    success: {
        backgroundColor: theme.palette.success.main
    },
    error: {
        backgroundColor: theme.palette.error.dark
    },
    info: {
        backgroundColor: theme.palette.primary.main
    },
    warning: {
        backgroundColor: theme.palette.error.light
    },
    icon: {
        fontSize: 20
    }
}));

export const SnackBarProviderWrapper = (props: {
    children: React.ReactNode;
}) => {
    // add action to all snackbars
    const classes = useStyles(props);
    const notistackRef = createRef();
    const onClickDismiss = key => () => {
        (notistackRef.current as any).closeSnackbar(key);
    };
    return (
        <SnackbarProvider
            ref={notistackRef}
            maxSnack={4}
            action={key => (
                <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    onClick={onClickDismiss(key)}
                >
                    <CloseIcon className={classes.icon} />
                </IconButton>
            )}
            classes={{
                variantSuccess: classes.success,
                variantError: classes.error,
                variantWarning: classes.warning,
                variantInfo: classes.info
            }}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right"
            }}
        >
            {props.children}
        </SnackbarProvider>
    );
};

export default SnackBarProviderWrapper;
